import { TreeNode } from "ui-library";

export const SideMenu: TreeNode[] = [
    {
      name: 'menu.dashboard.title',
      route: '',
      expanded: true,
      hidden: false,
      parent: true,
      loading: true,
      action: {
        icon: "settings",
        click: () => {}
      },
      fullyExpanded: false,
      children: []
    },
    {
      name: 'menu.projects.title',
      expanded: true,
      hidden: false,
      parent: true,
      children: [
        {
          icon: 'analytics',
          name: 'menu.timeline.title',
          route: 'report',
          children: []
        },
        {
          icon: 'view_in_ar',
          name: 'menu.viewer.3d',
          route: 'viewer/forge',
          children: []
        },
        {
          icon: 'map',
          name: 'menu.viewer.maps',
          route: 'viewer/maps',
          children: []
        },
        {
          icon: 'event_note',
          name: 'menu.plannings.title',
          route: 'plannings',
          children: []
        },
        {
          icon: 'gpp_maybe',
          name: 'menu.risks.title',
          route: 'risks',
          children: []
        },
        {
          icon: 'checklist',
          name: 'menu.actions.title',
          route: 'actions',
          children: []
        },
        {
          icon: 'smart_display',
          name: 'menu.timelapse.title',
          route: 'timelapse',
          children: []
        },
        // {
        //   icon: 'auto_awesome_mosaic',
        //   name: 'menu.imageMerging.title',
        //   route: 'image-merging',
        //   children: []
        // },
        {
          icon: 'switch_video',
          name: 'stream.title',
          route: 'stream',
          children: []
        }
      ]
    },
    {
      name: "menu.projects.params",
      expanded: true,
      hidden: false,
      parent: true,
      children:[
        {
          icon: 'info',
          name: 'settings.project.informations',
          route: 'project-settings/informations',
          children: []
        },
        {
          icon: 'location_on',
          name: 'title.resources',
          route: 'project-settings/resources',
          children: []
        },
        {
          icon: 'polyline',
          name: 'menu.workflows.title',
          route: 'workflows',
          expanded: true,
          children: []
        },
        {
          icon: 'category',//360
          name: 'settings.project.models',
          route: 'project-settings/models',
          children: []
        },
        {
          icon: 'people',
          name: 'settings.project.userList',
          route: 'project-settings/users',
          children: []
        },
        {
          icon: 'vpn_key',
          name: 'settings.project.privacy',
          route: 'project-settings/security',
          children: []
        },
        {
          icon: 'edit',
          name: 'settings.project.editTag',
          route: 'project-settings/tags',
          children: []
        },
        {
          icon: 'cloud_download',
          name: 'settings.project.database',
          route: 'project-settings/database',
          children: []
        },
        {
          icon: 'settings_remote',
          name: 'settings.project.kyd_reports',
          route: 'project-settings/kyd',
          children: []
        },
        {
          icon: 'engineering',
          name: 'menu.interventions.title',
          route: 'interventions',
          children: []
        },
        // {
        //   icon: 'help',
        //   name: 'Help',
        //   route: 'help',
        // },
      ]
    }
  ];